import type { CSSProperties } from 'react';
import { cn } from '@helios/ui';
import type { verifiedChangePresentation } from './verified-change';
import './verified-change-indicator.css';

/** Passive presentation only. Seen controls belong to the authenticated receipt workflow. */
export function VerifiedChangeIndicator({
  presentation,
  className,
}: {
  presentation: ReturnType<typeof verifiedChangePresentation>;
  className?: string;
}) {
  return (
    <span
      className={cn('verified-change', className)}
      data-tone={presentation.change.tone}
      data-pulsing={presentation.pulsing ? 'true' : 'false'}
      style={{ '--verified-change-delay': `-${presentation.pulseElapsedMs}ms` } as CSSProperties}
    >
      {presentation.unseen ? (
        <span className="verified-change-marker" aria-label="Unseen recorded change" />
      ) : null}
      <span>{presentation.change.text}</span>
    </span>
  );
}
